// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IContactDetailsAggregatorDto
 */
export interface IContactDetailsAggregatorDto {
    /**
     * 
     * @type {number}
     * @memberof IContactDetailsAggregatorDto
     */
    contact_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IContactDetailsAggregatorDto
     */
    first_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IContactDetailsAggregatorDto
     */
    last_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IContactDetailsAggregatorDto
     */
    role_name?: string;
}

/**
 * Check if a given object implements the IContactDetailsAggregatorDto interface.
 */
export function instanceOfIContactDetailsAggregatorDto(value: object): value is IContactDetailsAggregatorDto {
    return true;
}

export function IContactDetailsAggregatorDtoFromJSON(json: any): IContactDetailsAggregatorDto {
    return IContactDetailsAggregatorDtoFromJSONTyped(json, false);
}

export function IContactDetailsAggregatorDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IContactDetailsAggregatorDto {
    if (json == null) {
        return json;
    }
    return {
        
        'contact_id': json['contact_id'] == null ? undefined : json['contact_id'],
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
        'role_name': json['role_name'] == null ? undefined : json['role_name'],
    };
}

export function IContactDetailsAggregatorDtoToJSON(json: any): IContactDetailsAggregatorDto {
    return IContactDetailsAggregatorDtoToJSONTyped(json, false);
}

export function IContactDetailsAggregatorDtoToJSONTyped(value?: IContactDetailsAggregatorDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'contact_id': value['contact_id'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
        'role_name': value['role_name'],
    };
}

